import { Button, Dropdown, MenuProps } from 'antd';
import React from 'react';



export default function ExportCn(props: { orgaId: string }) {

    const items: MenuProps['items'] = [
  {
    key: '1',
    label: (
    <a
      target="_blank"
      rel="noopener noreferrer"
      href={`/exports/scn/${props.orgaId}/rdvs`}
    >
      Export des rendez-vous
    </a>
    ),
  },
  {
    key: '2',
    label: (
       <a
      target="_blank"
      rel="noopener noreferrer"
      href={`/exports/scn/${props.orgaId}/comment`}
    >
      Export des commentaires
    </a>
    ),
  },
  {
    key: '3',
    label: (
       <a
      target="_blank"
      rel="noopener noreferrer"
      href={`/exports/scn/${props.orgaId}/prospectsPerAtc`}
    >
      Export des prospects par atc
    </a>
    ),
  },
  {
    key: '4',
    label: (
       <a
      target="_blank"
      rel="noopener noreferrer"
      href={`/exports/scn/${props.orgaId}/switchProscpectsToOtherStatus`}
    >
      Export des bascules de prospects vers un autre statut
    </a>
    ),
  },
]

    return (
        <Dropdown menu={{ items }}>
            <Button>Exporter des données</Button>
        </Dropdown>
    );
}